import { useApi } from 'api/api-context';
import {
  DataSelectInheritedProps,
  DataSelect,
  DataMultiSelectInheritedProps,
  DataMultiSelect,
} from 'components/selects/DataSelect';

const LABEL_PROP = 'roleName' as const;
const VALUE_PROP = 'roleId' as const;
const ACTION_NAME = 'AuthListRoles' as const;

/**
 * Select input for roles.
 */
export function RoleSelect({ ...props }: DataSelectInheritedProps) {
  const { getAction } = useApi();
  return <DataSelect action={getAction(ACTION_NAME)} labelProp={LABEL_PROP} valueProp={VALUE_PROP} {...props} />;
}

/**
 * Select input for roles (multiple).
 */
export function RoleMultiSelect({ ...props }: DataMultiSelectInheritedProps) {
  const { getAction } = useApi();
  return <DataMultiSelect action={getAction(ACTION_NAME)} labelProp={LABEL_PROP} valueProp={VALUE_PROP} {...props} />;
}
